import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { userHasSuperSoundAccess } from "../constants/superSoundAccess";

export async function resolveSuperSoundLibraryAccess(email) {
  return userHasSuperSoundAccess(email, async (docId) =>
    getDoc(doc(db, "superSoundAccess", docId))
  );
}
